import React from 'react'
import styled from '@emotion/styled'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import SubPageTopBG from 'src/components/atoms/SubPageTopBG'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import { BreakPoint } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'

type Props = {
  title: string
  heading: string
}

const SubPageTopLayout = ({ title, heading }: Props) => {
  return (
    <SubPageTopBG>
      <ContentsWrapper>
        <TitleWrapper>
          <HeadingBorder heading={heading} />
          <HeadLine as="h1">{title}</HeadLine>
        </TitleWrapper>
      </ContentsWrapper>
    </SubPageTopBG>
  )
}

const HeadLine = styled(Typography)`
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: 2.88px;
  text-align: left;
  color: #22475d;
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    margin-left: 20px;
  }
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    font-size: 26px;
  }
`

const TitleWrapper = styled.div`
  padding: 100px 0 50px;
  @media screen and (max-width: ${BreakPoint.TABLET_MIN_WIDTH}) {
    padding: 100px 0 40px;
  }
`

export default SubPageTopLayout
